import Avatar from '@atlaskit/avatar-next';

import issacVargheseAvatarUrl from '../../assets/issac-varghese--color--product-purple.svg';
import jordanEllisAvatarUrl from '../../assets/jordan--color--dev-lime.svg';
import kaylaParajuliAvatarUrl from '../../assets/kayla-parajuli--color--teamwork-blue.svg';
import lailaAliAvatarUrl from '../../assets/laila-ali--color--service-yellow.svg';
import priyaHansraAvatarUrl from '../../assets/priya-hansra--color--teamwork-blue.svg';
import raulGonzalezAvatarUrl from '../../assets/raul-gonzalez--color--dev-lime.svg';
import robiLopezAvatarUrl from '../../assets/robi-lopez--color--service-yellow.svg';

const avatarUrls: Record<string, string> = {
	'Issac Varghese': issacVargheseAvatarUrl,
	'Jordan Ellis': jordanEllisAvatarUrl,
	'Kayla Parajuli': kaylaParajuliAvatarUrl,
	'Laila Ali': lailaAliAvatarUrl,
	'Priya Hansra': priyaHansraAvatarUrl,
	'Raul Gonzalez': raulGonzalezAvatarUrl,
	'Robi Lopez': robiLopezAvatarUrl,
};

export const EngineeringAvatar = ({ name }: { name: string }) => (
	<Avatar name={name} size="small" src={avatarUrls[name]} />
);
